import { MenuOutlined } from "@ant-design/icons";
import { SortableHandle } from "react-sortable-hoc";

const DragHandle = SortableHandle(() => (
    <MenuOutlined style={{ cursor: "pointer", color: "#999" }} />
));
export const renderSort = () => {
    return <DragHandle />;
};
